import {createContext, useContext} from "react";
import {User} from "../../../shared/client-server/types";

export interface AuthenticationContextType {
    user: User | null;
    accessToken: string | null;
    isAuthenticated: boolean;
    isLoading: boolean;
    login: (email: string, password: string) => Promise<boolean>;
    logout: () => Promise<void>;
    logoutAll: () => Promise<void>;
}

export const AuthenticationContext = createContext<AuthenticationContextType | undefined>(undefined);

// Custom hook for using auth context
export const useAuthentication = (): AuthenticationContextType => {
    const context = useContext(AuthenticationContext);

    if (context === undefined) {
        throw new Error('useAuthentication must be used within an AuthProvider');
    }

    return context;
};

